import { configureStore } from '@reduxjs/toolkit';
import clubReducer from './slices/clubSlice';

export const store = configureStore({
  reducer: {
    clubs: clubReducer,
    // slice‌های player, match, ticket و ... در فازهای بعدی به همین شکل اضافه می‌شوند
  },
});


